// Ön kayıt satış-takip modülü için ortak sabitler

export const PRE_REG_STATUS = {
    New: 0,
    Contacted: 1,
    FollowUp: 2,
    Converted: 3,
    NotConverted: 4,
};

export const STATUS_META = {
    0: { label: 'Yeni', color: 'blue', tag: 'processing' },
    1: { label: 'Arandı', color: 'cyan', tag: 'cyan' },
    2: { label: 'Tekrar Aranacak', color: 'orange', tag: 'orange' },
    3: { label: 'Satışa Döndü', color: 'green', tag: 'success' },
    4: { label: 'Satışa Dönmedi', color: 'red', tag: 'error' },
};

export const STATUS_OPTIONS = Object.entries(STATUS_META).map(([value, meta]) => ({
    value: Number(value),
    label: meta.label,
}));

export const SOURCE_META = {
    0: 'Belirtilmemiş',
    1: 'Web Sitesi',
    2: 'Telefon',
    3: 'Tavsiye',
    4: 'Sosyal Medya',
    5: 'Tesise Gelen',
    6: 'Diğer',
};

export const SOURCE_OPTIONS = Object.entries(SOURCE_META).map(([value, label]) => ({
    value: Number(value),
    label,
}));

export const ACTIVITY_TYPE = {
    Note: 0,
    Call: 1,
    StatusChange: 2,
    FollowUp: 3,
};

export const ACTIVITY_META = {
    0: { label: 'Not', color: 'blue' },
    1: { label: 'Arama', color: 'cyan' },
    2: { label: 'Durum Değişikliği', color: 'purple' },
    3: { label: 'Takip', color: 'orange' },
};
